module.exports = __webpack_public_path__ + "static/media/paladin_circle.1505d5cc.svg";